import { memo } from "react"

const IconLogout = () => {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.83333 22C1.34444 22 0.916667 21.8167 0.55 21.45C0.183333 21.0833 0 20.6556 0 20.1667V1.83333C0 1.34444 0.183333 0.916667 0.55 0.55C0.916667 0.183333 1.34444 0 1.83333 0H10.725V1.83333H1.83333V20.1667H10.725V22H1.83333ZM16.6833 16.3472L15.3694 15.0333L18.4861 11.9167H7.79167V10.0833H18.425L15.3083 6.96667L16.6222 5.65278L22 11.0306L16.6833 16.3472Z"
        fill="white"
      />
    </svg>
  )
}

export default memo(IconLogout)
